import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import BreadCrumbsNavbar from "../components/BreadCrumbsNavbar";
import { Bold16, Card, Main, Container } from "../components/common";
import Navbar from "../components/Navbar";
import HealthTable from "./HealthTable";
import AppContext from "../context/AppContext";

function Health(props) {
	const context = useContext(AppContext);
	const [data, setData] = useState([]);

	useEffect(() => {
		if (context.bankConnectApiKey == null) {
			fetchApiKey();
		} else {
			fetchHealthData();
		}
	}, []);

	const fetchHealthData = async (key) => {
		let apiKey = context.bankConnectApiKey;
		if (apiKey == null) {
			apiKey = key;
		}
		var myHeaders = new Headers();
		myHeaders.append("x-api-key", apiKey);
		var requestOptions = {
			method: "GET",
			headers: myHeaders,
			redirect: "follow",
		};
		let response;
		try {
			response = await fetch(
				`https://portal.finbox.in/bank-connect/v1/net_banking_health/`,
				requestOptions
			);
			if (response.status == 401) {
				window.location.href = "/bankconnect";
				return;
			}
		} catch (err) {
			context.removeToken();
			return;
		}
		const resp = await response.text();
		const json = JSON.parse(resp);
		if (json.length) {
			setData(json);
		}
	};

	const fetchApiKey = async () => {
		const resp = context.token;
		if (!resp) {
			window.location.href = "/";
		}
		const respJSON = JSON.parse(resp);
		var myHeaders = new Headers();
		myHeaders.append("token", respJSON.Token);

		var requestOptions = {
			method: "GET",
			headers: myHeaders,
			redirect: "follow",
		};

		const dresp = await fetch(
			"https://dashboardapi.finbox.in/v1/developer/bank_connect",
			requestOptions
		);
		const result = await dresp.json();
		const envs = result.Data.Env;
		console.log("envs", envs);
		let myAPIKey = null;
		if ("dev" in envs) {
			myAPIKey = envs["dev"][0]["Keys"][0].Value;
		}
		if ("prod" in envs) {
			myAPIKey = envs["prod"][0]["Keys"][0].Value;
		}
		context.updateBankConnectApiKey(myAPIKey);

		fetchHealthData(myAPIKey);
	};

	return (
		<Main>
			<BreadCrumbsNavbar
				color="blue"
				loc={[
					{ name: "BankConnect", link: "/bankconnect" },
					{ name: "Bank Status", link: props.location.pathname },
				]}
			/>
			<Container style={{ background: "white" }}>
				<div>
					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							marginBottom: "10px ",
						}}
					>
						<Bold16>Bank Status</Bold16>
					</div>
					<Card
						style={{
							display: "flex",
							flexDirection: "column",
							borderRadius: 10,
							border: "1px solid #ECECEC",
							padding: 0,
						}}
					>
						{data.length != 0 && <HealthTable data={data} />}
					</Card>
				</div>
			</Container>
		</Main>
	);
}

export default Health;
